export default __webpack_public_path__ + "static/media/Martinu.9bbd78aa.gif";